<i18n>
{
"en": {
  "DOCUMENTS": "Documents",
  "ATTACHEMENT": "Attachement",
  "DOWNLOADFILE": "Download File",
  "NOLABEL": "No Label"
},
"ar": {
 "DOCUMENTS":"مستندات",
 "ATTACHEMENT": "المرفق",
 "DOWNLOADFILE":"تحميل الملف",
 "NOLABEL": "لا ملصق"
}
}
</i18n>
<template>
    <el-dialog
        :title="$t(title)"
        :visible.sync="dialogVisible"
        size="tiny">
        <el-carousel indicator-position="outside"  @change="doResize" :arrow="document.length > 1 ? 'hover' : 'never'" :height="height + 'px'">
          <el-carousel-item  ref="caroItem" :key="index" v-for="(doc, index) in document">
            <h3>
              <el-row v-if="filterExtension(doc.file_name)" style="position: absolute; top:30%;width:100%;text-align: center">
                <i :class="['fa',filterExtension(doc.file_name),'fa-5x']"></i><br><br>
                <a target="_blank" :href="getAsset(doc.file_name)"><i class="fa fa-cloud-download"></i> {{$t('DOWNLOADFILE')}}</a>
              </el-row>
              <img v-else :src="getAsset(doc.file_name)" style="width: 100%;">
              <el-row style="width:100%;text-align: center" v-text="doc.label || $t('NOLABEL')"></el-row>
            </h3>
          </el-carousel-item>
        </el-carousel>
    </el-dialog> 
</template>

<script>
  export default {
    name: 'ElDocDialog',
    componentName: 'ElDocDialog',
    props: {
      document: {
        type: Array,
        default: function () {
          return []
        }
      },
      visible: {
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: 'DOCUMENTS'
      },
      subFolder: {
        type: String,
        default: 'documents'
      }
    },
    watch: {
      dialogVisible () {
        this.$emit('update:visible', this.dialogVisible)
      },
      visible () {
        this.switchLanguage()
        this.dialogVisible = this.visible
        this.height = 300
        this.doResize(0)
      }
    },
    data () {
      return {
        dialogVisible: false,
        fileType: {'pdf': 'fa-file-pdf-o red-color', 'doc': 'fa-file-word-o blue-color', 'docx': 'fa-file-word-o blue-color'},
        height: 300
      }
    },
    updated () {
    },
    methods: {
      getDoc (image) {
       // return this.getAsset(image, 'bus')
      },
      filterExtension (value) {
        let ext = value.split('.')
        if (this.fileType[ext[1]] !== undefined) return this.fileType[ext[1]]
        return false
      },
      doResize (index) {
        if (this.$refs.caroItem === undefined || !this.visible) return
        this.$nextTick(function () {
          let image = this.$refs.caroItem[index].$el.children[0].children[0]
          if (image === undefined) return
          if (image.clientHeight !== 0) {
            this.height = image.clientHeight + 50
            if (this.height < 300) this.height = 300
            return
          }
          let self = this
          image.addEventListener('load', function () {
            self.height = this.height + 50
            if (self.height < 300) self.height = 300
          })
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Doc.vue?5d2e81ae